import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosResponse} from 'axios';
//enum
import {ACTION_TYPE} from '../actions-types';
//helpers
import {getErrorResponse} from '@/utils/helpers';
import {
	IUserOrganizationSettingData,
	IRequestAddVipPhone,
	IVipPhoneData,
	IOrganizationSettingReqData,
} from '@/utils/types';
import {OrganizationNotificationSettingService} from '@/utils/services';

//vip phones numbers
export const organizationGetVipPhones = createAsyncThunk(
	ACTION_TYPE.NOTIFICATION_SETTING_PHONE_LIST,
	async (organizationId: number, {rejectWithValue}) => {
		try {
			const organizationResponse: AxiosResponse<IVipPhoneData[]> =
				await OrganizationNotificationSettingService.getAllVipPhones(organizationId);
			return organizationResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const organizationAddVipPhone = createAsyncThunk(
	ACTION_TYPE.NOTIFICATION_SETTING_CREATE_PHONE,
	async (reqBody: IRequestAddVipPhone, {rejectWithValue}) => {
		try {
			const organizationResponse: AxiosResponse<IVipPhoneData> =
				await OrganizationNotificationSettingService.createVipPhones(reqBody);
			return organizationResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const organizationDeleteVipPhone = createAsyncThunk(
	ACTION_TYPE.NOTIFICATION_SETTING_DELETE_PHONE,
	async (numberId: number, {rejectWithValue}) => {
		try {
			await OrganizationNotificationSettingService.deleteVipPhones(numberId);
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

// get organizatiopn notification setting
export const organizationGetNotificationSettings = createAsyncThunk(
	ACTION_TYPE.NOTIFICATION_SETTING_LIST,
	async (organizationId: number, {rejectWithValue}) => {
		try {
			const organizationResponse: AxiosResponse<IUserOrganizationSettingData> =
				await OrganizationNotificationSettingService.getAllNotificationSetting(organizationId);
			return organizationResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

//update  organizatiopn notification setting
export const organizationUpdateNotificationSettings = createAsyncThunk(
	ACTION_TYPE.NOTIFICATION_SETTING_UPDATE_LIST,
	async ({id, reqBody}: IOrganizationSettingReqData, {rejectWithValue}) => {
		try {
			const organizationResponse: AxiosResponse<IUserOrganizationSettingData> =
				await OrganizationNotificationSettingService.updateNotificationSetting(id, reqBody);
			return organizationResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
